module.exports = __webpack_public_path__ + "img/TRX.282a7fad.svg";